import { translate } from '@/domains/core/localization/translate';
export const {
  anonymousUser,
  proCustomer,
  translatedByGoogle
} = translate({
  "translatedByGoogle": "Translated by Google",
  "proCustomer": "ManoManoPro customer",
  "anonymousUser": "Anonymous"
});